import useTranslation from "../../hooks/useTranslation";

const TimelinePCR = ({ data, startTime, endTime }) => {
  const T = useTranslation();
  const colorGreenSecondary = "#BBDFDB";

  const totalDuration = endTime - startTime;

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
      }}
    >
      {data?.map((item, index) => {
        const leftPercent = ((item.start - startTime) / totalDuration) * 100;
        const widthPercent = ((item.stop - item.start) / totalDuration) * 100;

        return (
          <div key={index}>
            {/* Interval bar */}
            <div
              style={{
                position: "absolute",
                top: "45%",
                left: `${leftPercent}%`,
                width: `${widthPercent}%`,
                height: "6px",
                backgroundColor: colorGreenSecondary,
                borderRadius: "3px",
              }}
            />
            {/* RCP Label */}
            <div
              style={{
                position: "absolute",
                top: 7,
                left: `${leftPercent}%`,
                fontSize: "10px",
                transform: "translateX(-50%)",
              }}
            >
              {T("RCP")}
            </div>
            <div
              style={{
                position: "absolute",
                bottom: 7,
                left: `${leftPercent + widthPercent}%`,
                fontSize: "10px",
                transform: "translateX(-50%)",
              }}
            >
              {T("RCE")}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TimelinePCR;
